// styled components
import {LinksList, List, MainItem} from '../style';
import {colors} from '@styles/vars';

// components
import Accordion from 'react-bootstrap/Accordion';
import {NavLink} from 'react-router-dom';
import {authService} from '@services/auth.service';
import {isAdminOrSuperAdmin, isStandardUserRole, isSuperAdmin} from '@utils/roleAccess';

// hooks
import {useSidebarContext} from '@contexts/sidebarContext';
// menu links
import {menu} from '@constants/menu';

const Content = ({isCollapsed}) => {
    const {toggleSidebar} = useSidebarContext();
    const activeStyle = {color: colors.blue};
    const currentUser = authService.getUser();
    const canSeeAdminLinks = isAdminOrSuperAdmin(currentUser);
    const canSeeSuperAdminLinks = isSuperAdmin(currentUser);

    return (
        <List as={Accordion}>
            {
                menu.map((item, index) => {
                    if (item.cat) {
                        return (
                            <Accordion.Item eventKey={item.cat} key={item.cat}>
                                <MainItem as={Accordion.Header} className={isCollapsed ? 'collapsed' : ''} data-tour-sidebar={item.cat}>
                                    <i className={`icon icon-${item.icon}`}></i>
                                    {!isCollapsed && <span>{item.cat}</span>}
                                </MainItem>
                                {!isCollapsed && (
                                    <Accordion.Body>
                                        <LinksList>
                                            {
                                            item.links
                                            .filter(link => {
                                                if (link.excludeUserRole && isStandardUserRole(currentUser)) {
                                                    return false;
                                                }
                                                if (link.superAdminOnly && !canSeeSuperAdminLinks) {
                                                    return false;
                                                }
                                                return !link.adminOnly || canSeeAdminLinks;
                                            })
                                            .map(link => {
                                                return (
                                                    <li key={link.link}>
                                                        <NavLink to={link.link}
                                                                 onClick={() => toggleSidebar()}
                                                                 data-tour-link={link.link}
                                                                 style={({isActive}) =>
                                                                     isActive ? activeStyle : undefined
                                                                 }
                                                        >
                                                            {link.name}
                                                        </NavLink>
                                                    </li>
                                                )
                                            })
                                            }
                                        </LinksList>
                                    </Accordion.Body>
                                )}
                            </Accordion.Item>
                        )
                    } else if (item.link) {
                        return (
                            <MainItem as={NavLink}
                                      to={item.link}
                                      onClick={() => toggleSidebar()}
                                      style={({isActive}) =>
                                          isActive ? activeStyle : undefined
                                      }
                                      key={item.link}
                                      className={`${index === menu.length - 1 ? 'pin-down' : ''} ${isCollapsed ? 'collapsed' : ''}`}
                            >
                                <i className={`icon icon-${item.icon}`}></i>
                                {!isCollapsed && <span>{item.name}</span>}
                            </MainItem>
                        )
                    } else return null
                })
            }
        </List>
    )
}

export default Content;